<div class="app-chat-viewer bc-work-item-theme bc-panel {{chatThemeClass}}"
     cdkDrag [cdkDragDisabled]="!draggable" [cdkDragBoundary]="dragBoundaryElementSelector"
     (cdkDragEnded)="dragFinishedHandler()">
  <ng-container *ngIf="workItem && visitor && !messagesLoading">
    <work-widget-header class="column-flex-fix bc-panel preview-header"
                        *ngIf="draggable"
                        cdkDragHandle
                        [workItem]="workItem"
                        [title]="visitor.fields.name.value || visitor.fields.email.value"
                        [visitor]="visitor"
                        [previewMode]="true"
                        (closeAction)="closeButtonClicked()"></work-widget-header>
    <workitem-activity-indicator
      *ngIf="showActivityIndicator"
      [unansweredMessageCount]="getUnansweredMessageCount()">
    </workitem-activity-indicator>
    <div class="messages-container" #scrollPane>
      <app-chat-messages [messages]="messages" *ngIf="!messagesLoading"
                         [isActive]="false"
                         [workItemId]="chatId"
                         [workItemCreated]="workItemCreated"
                         [workItemType]="workItemType"
                         [canAgentProposeArticle]="false"
                         (rendered)="onChatMessagesRendered()"
      ></app-chat-messages>
    </div>

    <app-chat-actions *ngIf="isConversationActive()"
                      [isChatInProgress]="isChatInProgress()"
                      [isAnswerable]="isChatAnswerable()"
                      (answerChat)="answerChat()"
                      [isDisconnected]="false"
                      [isWrapUpPanelActive]="false"
                      [chatId]="chatId"
                      [messages]="messages"
                      [visitorName]="workItem.ChatName"></app-chat-actions>
    <div class="editor-container">
      <a (click)="toggleCannedMessagePanel()"
         *ngIf="isEditorVisible"
         class="btn btn-borderless btn-cm">
        <svg-icon icon="can-outline"></svg-icon>
      </a>
      <app-join-chat [chatId]="chatId" (joinStateChanged)="onJoinStateChange()" [hasFullScreenRc]="hasFullScreenRc"></app-join-chat>
    </div>
    <app-canned-message-panel
      [cannedMessageRequest]="cannedMessageRequest"
      [workItemId]="workItem.id"
      [eventTargetId]="workItem.id + '-chat-viewer'"
      [isOpened]="isCannedMessagePanelOpen"
      [isExpanded]="false"
    >
    </app-canned-message-panel>
  </ng-container>
  <app-loading *ngIf="!workItem || !visitor || messagesLoading"></app-loading>
</div>
